<template>
  <div>
    <table class="fx-form-view">
      <col width="150px"/>
      <col/>
      <tr>
        <th>评价人</th>
        <td>
          {{ info.extras.userName }}
        </td>
      </tr>
      <tr>
        <th>评价时间</th>
        <td>
          {{ info.addTime }}
        </td>
      </tr>
      <tr>
        <th>被评专家</th>
        <td>
          {{ info.extras.expertName }}
        </td>
      </tr>
      <tr>
        <th>评价等级</th>
        <td>
          {{ info.extras.levelName }}
        </td>
      </tr>
      <tr>
        <th>评分</th>
        <td>
          {{ info.score }}
        </td>
      </tr>
      <tr>
        <th>评价内容</th>
        <td>
          {{ info.content }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ExpertYearAssessViewTable',
  components: {
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return { extras: { } }
      }
    },
    hiddenHtml: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  created() {
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
  .link {
    color: rgb(24, 144, 255);
  }

  .action button {
    margin-right: 4px;
  }

  .card {
    margin-bottom: 24px;

    .extras {
      font-weight: 500;
      font-size: 16px;
    }
  }

  .nav {
    .title {
      text-align: center;
      font-weight: 800;
    }

    .footer {
      text-align: right;
    }
  }

  .titleCap {
    margin-bottom: 12px;

    .receiveNum {
      padding-left: 16px;
    }

    > span {
      border-right: 1px solid #e6e6e6;
      padding: 0 20px;
    }

    > span:nth-last-child(1) {
      border-right: none;
    }

    > span:nth-child(2) {
      padding-left: 0;
    }
  }
</style>
